export default "__VITE_ASSET__5W6AlJHE__"